import React from 'react';
import { Icon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Material icons: https://material.io/resources/icons/?icon=accessibility&style=baseline

export default function Hungary(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width}
			height={props.height}
			viewBox='0 0 512 512'>
			<rect
				xmlns='http://www.w3.org/2000/svg'
				y='85.337'
				fill='#F0F0F0'
				width='512'
				height='341.326'
			/>
			<rect
				xmlns='http://www.w3.org/2000/svg'
				y='85.337'
				fill='#D80027'
				width='512'
				height='113.775'
			/>
			<rect
				xmlns='http://www.w3.org/2000/svg'
				y='312.888'
				fill='#6DA544'
				width='512'
				height='113.775'
			/>
		</svg>
	);
}
